<template>
	<div class="single-option pb-1 flex-space-between--center">
		<div class="hover-effect"><SIcon name="drag-sign" /></div>
		<div class="inputs" :class="{ 'flex-column': isOptionValue }">
			<div class="text-field-style">
				<CombinedInputFieldDataMenu
					noPrefix
					ref="mainInput"
					:noSuffix="noSuffix"
					:readonly="readonly"
					:textAreaMode="false"
					:prefixStyle="prefixStyle"
					:suffixStyle="suffixStyle"
					:value.sync="localData.text"
					:disableEnter="!isOptionValue"
					:placeholder="keyPlaceholderLocal"
					@content-updated="onContentUpdate"
					:valuesTypes="ITEM_ONLY_ALLOWED_VALUE_TYPES"
					@remove="() => $emit('removeOption', localData)"
				/>
			</div>
			<div class="text-field-style mt-1" v-if="isOptionValue">
				<CombinedInputFieldDataMenu
					ref="mainInput"
					:noSuffix="noSuffix"
					:noPrefix="noSuffix"
					:readonly="readonly"
					:textAreaMode="false"
					:prefixStyle="prefixStyle"
					:suffixStyle="suffixStyle"
					:value.sync="localData.value"
					:placeholder="valuePlaceholder"
					@content-updated="onContentUpdate"
					:valuesTypes="valueInsertDataAllowedTypes"
				/>
			</div>
		</div>
		<!-- will be usable soon -->
		<!-- <div v-if="allowMultipleValue">
			<AppCheckbox :isOn="isMultiple" @update:isOn="(v) => (isMultiple = v)" dense label="Multiple?" />
		</div> -->
		<RoundButton v-show="canRemove && !readonly" @click="$emit('removeOption', localData)">
			<RemoveSvg />
		</RoundButton>
		<div v-if="data.required != undefined">
			<v-menu :close-on-content-click="false" content-class="men" min-width="300" absolute left bottom>
				<template v-slot:activator="{ on, attrs }">
					<RoundButton class="conf-btn" v-bind="attrs" v-on="on"><ConfSvg /></RoundButton>
				</template>
				<v-list dense>
					<v-list-item>
						<div class="flex-1 flex-space-between--center">
							<div>Required</div>
							<AppSwitch primary-color v-model="isRequiredLocal" />
						</div>
					</v-list-item>
				</v-list>
			</v-menu>
		</div>
	</div>
</template>

<script>
import ConfSvg from './assets/ConfSvg';
import RemoveSvg from './assets/RemoveSvg';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import {
	ITEM_ONLY_ALLOWED_VALUE_TYPES,
	TABLE_ONLY_ALLOWED_VALUE_TYPES,
	TABLE_AND_ITEM_ALLOWED_VALUE_TYPES,
} from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';

export default {
	name: 'SingleOption',
	components: {
		ConfSvg,
		RemoveSvg,
		CombinedInputFieldDataMenu,
	},
	props: {
		data: { type: Object },
		noSuffix: { type: Boolean },
		readonly: { type: Boolean },
		isOptionValue: { type: Boolean, default: false },
		canRemove: { type: Boolean, default: true },
		keyPlaceholder: { type: String },
		valuePlaceholder: { type: String, default: 'Value' },
		allowMultipleValue: { type: Boolean },
		allowTableAndItemValue: { type: Boolean },
	},
	computed: {
		isRequiredLocal: {
			get() {
				return this.data.required;
			},
			set(value) {
				this.localData = { ...this.localData, ...{ required: value } };
			},
		},
		prefixStyle() {
			return { 'margin-left': '22px !important' };
		},
		suffixStyle() {
			return { 'margin-right': '42px !important', 'margin-top': '-1px !important' };
		},
		keyPlaceholderLocal() {
			return this.keyPlaceholder ? this.keyPlaceholder : this.isOptionValue ? 'Key' : 'Type option...';
		},
		valueInsertDataAllowedTypes() {
			if (this.allowTableAndItemValue) {
				return TABLE_AND_ITEM_ALLOWED_VALUE_TYPES;
			} else if (this.localData.multiple) {
				return TABLE_ONLY_ALLOWED_VALUE_TYPES;
			} else {
				return ITEM_ONLY_ALLOWED_VALUE_TYPES;
			}
		},
		isMultiple: {
			set(value) {
				if (value !== !!this.localData.multiple) {
					this.localData.value = ''; // clear value if type of acceptable value has changed
				}
				this.$set(this.localData, 'multiple', value);
			},
			get() {
				return this.localData.multiple;
			},
		},
	},
	watch: {
		localData: {
			handler(newV) {
				this.$emit('updateOption', newV);
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		onContentUpdate(k) {
			if (k === 'Enter' && !this.isOptionValue && this.localData.text?.length > 1) {
				this.onEnterKey();
			}
		},
		updateText(e) {
			this.localData.text = e.target.value;
			if (!this.isOptionValue) {
				this.localData.value = e.target.value;
			}
		},
		updateOptionValue(e) {
			this.localData.value = e.target.value;
		},
		onEnterKey() {
			this.$emit('onEnterKey');
		},
		focusInput() {
			this.$refs.mainInput?.focus();
		},
	},
	data() {
		return {
			localSwitch: false,
			localData: { ...this.data },
			ITEM_ONLY_ALLOWED_VALUE_TYPES,
		};
	},
};
</script>

<style scoped lang="scss">
.single-option {
	> div:not(:nth-child(1)),
	> button {
		margin: 0 0 0 10px;
	}

	.inputs {
		width: 100%;

		.text-field-style {
			padding: 0;
			border: none;
			border-radius: 6px;
			background-color: #ffffff;
		}
	}

	.conf-btn {
		background-color: #d4d7dc;
	}
}
</style>
